module.exports = __webpack_public_path__ + "static/media/fire-88.3cfdaa4a.gif";